/**
 * Returns true when the URL points to a different origin than the current page.
 *
 * Treats relative paths, in-page anchors (`#…`), `mailto:`, etc. as internal.
 * Falls back to a syntactic check (any absolute http(s) URL is external) when
 * `window.location` is unavailable, e.g. during server-side rendering.
 */
export const isExternalUrl = (url: string | undefined | null): boolean => {
    if (!url) return false
    if (!/^https?:\/\//i.test(url)) return false
    try {
        const linkHost = new URL(url).host
        if (typeof window === 'undefined') return true
        return linkHost !== window.location.host
    } catch {
        return false
    }
}
